import { render, staticRenderFns } from "./DemoV2.vue?vue&type=template&id=f14a8e60"
import script from "./DemoV2.vue?vue&type=script&lang=js"
export * from "./DemoV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports